/* eslint-disable no-prototype-builtins */
import { isEmpty, isObject, properObject } from "@/utils/utils";

export const deletedDiff = <T>(
  lhs: T,
  rhs: Record<string, unknown> | T,
  omitRules: Array<string | ((key: string) => boolean)> = []
): Partial<NonNullable<T>> => {
  if (lhs === rhs || !isObject(lhs) || !isObject(rhs)) return {};

  const l = properObject(lhs as Record<string, unknown>);
  const r = properObject(rhs as Record<string, unknown>);

  return Object.keys(l).reduce((acc, key) => {
    for (const rule of omitRules) {
      if (typeof rule === "string") {
        if (key === rule) return acc;
      } else if (typeof rule === "function") {
        if (rule(key)) return acc;
      }
    }

    if (r.hasOwnProperty(key)) {
      const difference = deletedDiff(
        l[key as string] as Record<string, unknown>,
        r[key as string] as Record<string, unknown>,
        omitRules
      );

      if (isObject(difference) && isEmpty(difference)) return acc;

      return { ...acc, [key]: difference };
    }

    return { ...acc, [key]: undefined };
  }, {});
};
